import { Time } from '@morpho-org/morpho-ts'

import type { MarketPosition } from '@/lib/procedures/marketPosition.contract'
import type {
  MarketPositionMarket,
  PositionToken
} from '@/lib/procedures/marketPositionMarket.contract'
import type { HistoryRange } from '@/lib/transforms/history/window'

import { toUsdValue } from '@/lib/transforms/history/series'

const usdOf = (token: PositionToken | null, amount: string) =>
  token === null ? null : toUsdValue(BigInt(amount), token.decimals, token.priceUsd)

/**
 * The chart's headline: the current position, natively and in USD at Core's spot price. A USD
 * value is null when Core cannot price the token or the market has no collateral token.
 */
export function toPositionTotals(position: MarketPosition, market: MarketPositionMarket) {
  return {
    borrowAssets: position.borrowAssets,
    collateral: position.collateralAssets,
    borrowAssetsUsd: usdOf(market.loanToken, position.borrowAssets),
    collateralUsd: usdOf(market.collateralToken, position.collateralAssets),
    supplyAssetsUsd: usdOf(market.loanToken, position.supplyAssets)
  }
}

/** The history range a time frame option reads; `null` is all time. */
export function toHistoryRange(timeFrame: Time.PeriodLike | null): HistoryRange {
  if (timeFrame === null) return 'all'
  const seconds = Time.s.fromPeriod(timeFrame)
  if (seconds <= Time.s.fromPeriod('w')) return '1w'
  if (seconds <= Time.s.fromPeriod('mo')) return '1m'
  return '3m'
}
